export default [
    {
        path: '/download',
        props: true,
        component: () => import('@/views/Download'),
    },
];